import { fetchRefreshIntegrated, getBaseUrl } from "../api.utils";

export const startConnectionWithHub = async (): Promise<boolean> => {
    const baseConfigTemplatesURL = await getBaseUrl("hub");
    return await fetchRefreshIntegrated<boolean>(
        `${baseConfigTemplatesURL}/startConnectionWithHub`
    );
};
